<div #creditReport>
  @for (consumer of consumerReport?.consumers || []; track consumer; let consumerIndex = $index) {
    <div class="credit-report break-after">
      <h1 class="pdf-reactor-d-none">{{ 'content.transunion-consumer-credit-report' | translate }}</h1>
      @if (isNoHit(consumer) && (!creditFreezeMessage(consumer))) {
        <div>
          {{ 'content.unable-to-find-a-file-for' | translate }} {{ primaryGivenNames(consumerRequest!.consumers[consumerIndex]) }}
        </div>
      }
      @if (consumer.rbId.amlId) {
        <div class="d-flex flex-row justify-content-center mb-5">
          <div>{{ 'content.identifier' | translate }}: {{ consumer.rbId.amlId }}</div>
        </div>
      }
      @if (isHit(consumer) || creditFreezeMessage(consumer)) {
        <div>
          @if (isCreditFreezeAndIsNonExemptedMC(consumer)) {
            <div>
              <h4>
                {{ 'content.credit-freeze-msg-non-exempt' | translate:{consumername: getFullNameFromConsumerRequest(consumer, consumerRequest)} }}{{ 'content.credit-freeze-date' | translate: {freezedate: getCreditFreezeDate(consumer)} }}
              </h4>
            </div>
          }
          <h2 class="visually-hidden">{{ 'content.subject' | translate }}</h2>
          @if (!isCreditFreezeAndIsNonExemptedMC(consumer)) {
            <div >
              <div class="row">
                <h3 class="col-sm-12 col-md-2">{{ 'content.subject' | translate }}</h3>
                <div class="col-sm-6 col-md-2">
                  <h4>{{ 'content.surname' | translate }}</h4>
                  <div>{{ primaryName(consumer)?.lastName }}</div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <h4>{{ 'content.given-names' | translate }}</h4>
                  <div>{{ primaryGivenNames(consumer) }}</div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <h4>{{ 'content.social-insurance-number-short2' | translate }}</h4>
                  <div>{{ maskStart(this.consumerRequest.consumers[0]?.sin, 3) }}</div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <h4>{{ 'content.person.birth' | translate }}</h4>
                  <div>{{ dayMonthYear(consumer.subjectPersonal?.dob) }}</div>
                </div>
              </div>
              @for (name of secondaryNames(consumer); track name) {
                <div class="row">
                  <h3 class="col-sm-6 col-md-2">{{ 'content.cross-ref-also-known-as' | translate }}</h3>
                  <div class="col-sm-6 col-md-2">
                    <div>{{ name.lastName }}</div>
                  </div>
                  <div class="col-sm-6 col-md-2">
                    <div>{{ name.firstName }} {{ name.middleName }}</div>
                  </div>
                </div>
              }
              <div class="row">
                <div class="col-sm-6 col-md-2">
                  <h4>{{ 'content.on-file' | translate }}</h4>
                  <div>{{ dayMonthYear(consumer.subject.onFileDate) }}</div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <h4>{{ 'content.last-inquiry' | translate }}</h4>
                  <div>{{ dayMonthYear(consumer.subject.lastInqDate, "DDMMYYYY")}}</div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <h4>{{ 'content.current-residence' | translate }}</h4>
                  <div>{{ primaryAddress(consumer) }}</div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <h4>{{ 'content.phone.phone' | translate }}</h4>
                  <div>{{ primaryPhone(consumer) }}</div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <h4>{{ 'content.prev-phone' | translate }}</h4>
                  <div>{{ prevPhone(consumer) }}</div>
                </div>
              </div>
            </div>
          }
          <!-- Setting ngIf = false according to requirement for removing IDX -->
          @if (consumer.idxUniqueIdentifier && !isCreditFreezeAndIsNonExemptedMC(consumer)) {
            <div style = "display:none" >
              <h2>{{ 'content.idx' | translate }}</h2>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <h3 class="col-6">{{ 'content.identifier' | translate }}</h3>
                    <div class="col-6">{{ formatIdxIdentifier(consumer) | async }}</div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (!isCreditFreezeAndIsNonExemptedMC(consumer)) {
            <div>
              <h2>{{ 'content.residences' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-3">{{ 'content.address.street' | translate }}</h3>
                <h3 class="col-3">{{ 'content.address.city' | translate }}</h3>
                <h3 class="col">{{ 'content.address.province-short' | translate }}</h3>
                <h3 class="col">{{ 'content.address.postal' | translate }}</h3>
                <h3 class="col">{{ 'content.since' | translate }}</h3>
                <h3 class="col">{{ 'content.confirm-short' | translate }}</h3>
              </div>
              @for (address of addresses(consumer); track address) {
                <div class="row">
                  <div class="col-sm-6 col-md-5 col-lg-3">
                    <h3 class="d-lg-none">{{ 'content.address.street' | translate }}</h3>
                    <div>{{ civicStreet(address) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <h3 class="d-lg-none">{{ 'content.address.city' | translate }}</h3>
                    <div>{{ address.city }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.address.province-short' | translate }}</h3>
                    <div>{{ address.province }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.address.postal' | translate }}</h3>
                    <div>{{ reformatPostal(address.postal) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.since' | translate }}</h3>
                    <div>{{ monthYear(address.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.confirm-short' | translate }}</h3>
                    <div>{{ monthYear(address.dateConfirmed) }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.customMessage?.length > 0) {
            <div>
              <h2>{{ 'content.custom-decisioning' | translate }}</h2>
              @for (message of consumer.customMessage; track message) {
                <div>{{ message.customMessage }}</div>
              }
            </div>
          }
          @if (consumer.employments?.length > 0) {
            <div>
              <h2>{{ 'content.employments' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-5">{{ 'content.employers-name-and-address' | translate }}</h3>
                <h3 class="col-3">{{ 'content.person.occupation' | translate }}</h3>
                <h3 class="col-2">{{ 'content.since' | translate }}</h3>
                <h3 class="col-2">{{ 'content.confirm-short' | translate }}</h3>
              </div>
              @for (employer of consumer.employments; track employer) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-5">
                    <h3 class="d-lg-none">{{ 'content.employers-name-and-address' | translate }}</h3>
                    <div>{{ formatEmployerNameAddress(employer.employer, employer.employerAddress) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <h3 class="d-lg-none">{{ 'content.person.occupation' | translate }}</h3>
                    <div>{{ employer.occupation }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-2">
                    <h3 class="d-lg-none">{{ 'content.since' | translate }}</h3>
                    <div>{{ dayMonthYear(employer.dateSince) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-2">
                    <h3 class="d-lg-none">{{ 'content.confirm-short' | translate }}</h3>
                    <div>{{ dayMonthYear(employer.dateConfirmed) }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (displayFileSummary && !isCreditFreezeAndIsNonExemptedMC(consumer)) {
            <div>
              <h2>{{ 'content.file-summary' | translate }}</h2>
              @if (consumer.creditSummary2) {
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="row">
                      <h3 class="col-6">{{ 'content.bankruptcies' | translate }}</h3>
                      <div class="col-6">{{ summaryCountDate(consumer.creditSummary2.bkCount, consumer.creditSummary2.bkNewestDt) }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.legal-items' | translate }}</h3>
                      <div class="col-6">{{ summaryCountDate(consumer.creditSummary2.leCount, consumer.creditSummary2.leNewestDt) }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.collections' | translate }}</h3>
                      <div class="col-6">{{ summaryCountDate(consumer.creditSummary2.clCount, consumer.creditSummary2.clNewestDt) }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.banking-closed-for-cause' | translate }}</h3>
                      <div class="col-6">{{ summaryCountDate(consumer.creditSummary2.cfCount, consumer.creditSummary2.cfNewestDt) }}</div>
                    </div>
                    <div class="row d-none d-lg-block"></div><!-- &nbsp; -->
                    <div class="row">
                      <h3 class="col-6">{{ 'content.trade-first-opened' | translate }}</h3>
                      <div class="col-6">{{ monthYear(consumer.creditSummary2.trOldestDtOpen) }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.trade-last-opened' | translate }}</h3>
                      <div class="col-6">{{ monthYear(consumer.creditSummary2.trNewestDtOpen) }}</div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="row">
                      <h3 class="col-6">{{ 'content.registered-items' | translate }}</h3>
                      <div class="col-6">{{ summaryCountDate(consumer.creditSummary2.regCount, consumer.creditSummary2.regNewestDt) }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.inquiries' | translate }}</h3>
                      <div class="col-6">{{ summaryCountDate(consumer.creditSummary2.inCount, consumer.creditSummary2.inNewestDt) }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.collection-inquiries' | translate }}</h3>
                      <div class="col-6">{{ consumer.creditSummary2.inCollInqq24 }}</div>
                    </div>
                    <div class="row">
                      <h3 class="col-6">{{ 'content.inquiries-within-6-months' | translate }}</h3>
                      <div class="col-6">{{ consumer.creditSummary2.inWithin6Months }}</div>
                    </div>
                    <div class="row d-none d-lg-block"></div><!-- &nbsp; -->
                    @if (consumer.creditSummary) {
                      <div class="row">
                        <h3 class="col-6">{{ 'content.current-negative-trades' | translate }}</h3>
                        <div class="col-6">{{ getNegativeTrades(consumer) }}</div>
                      </div>
                    }
                    <div class="row">
                      <h3 class="col-6">{{ 'content.paid-trade' | translate }}</h3>
                      <div class="col-6">{{ consumer.creditSummary2.trPaid }}</div>
                    </div>
                  </div>
                </div>
              }
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col pdf-reactor-8-percent">{{ 'content.type' | translate }}</h3>
                <h3 class="col pdf-reactor-8-percent">{{ 'content.count' | translate }}</h3>
                <h3 class="col pdf-reactor-13-percent">{{ 'content.highcred' | translate }}</h3>
                <h3 class="col pdf-reactor-13-percent">{{ 'content.credlimit' | translate }}</h3>
                <h3 class="col pdf-reactor-13-percent">{{ 'content.balance' | translate }}</h3>
                <h3 class="col pdf-reactor-13-percent">{{ 'content.past-due' | translate }}</h3>
                <h3 class="col pdf-reactor-13-percent">{{ 'content.payment' | translate }}</h3>
                <h3 class="col pdf-reactor-13-percent">{{ 'content.available' | translate }}</h3>
              </div>
              @for (csd of consumer.creditSummaryDetail || []; track csd) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-8-percent">
                    <h3 class="d-lg-none">{{ 'content.type' | translate }}</h3>
                    <div>{{ csd.summaryType === 'T' ? ('content.total' | translate) : csd.summaryType }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-8-percent">
                    <h3 class="d-lg-none">{{ 'content.count' | translate }}</h3>
                    <div>{{ csd.summaryType === 'T' ? getTotalCreditSummaryDetailCount(consumer) : getCreditSummaryDetailCount(consumer, csd) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-13-percent">
                    <h3 class="d-lg-none">{{ 'content.highcred' | translate }}</h3>
                    <div>{{ formatCurrency(csd.highCredit) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-13-percent">
                    <h3 class="d-lg-none">{{ 'content.credlimit' | translate }}</h3>
                    <div>{{ formatCurrency(csd.creditLimit) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-13-percent">
                    <h3 class="d-lg-none">{{ 'content.balance' | translate }}</h3>
                    <div>{{ formatCurrency(csd.balance) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-13-percent">
                    <h3 class="d-lg-none">{{ 'content.past-due' | translate }}</h3>
                    <div>{{ formatCurrency(csd.amountPastDue) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-13-percent">
                    <h3 class="d-lg-none">{{ 'content.payment' | translate }}</h3>
                    <div>{{ formatCurrency(csd.monthlyPayment) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg pdf-reactor-13-percent">
                    <h3 class="d-lg-none">{{ 'content.available' | translate }}</h3>
                    <!-- Legacy only calculated this for type R.  Everything else it was hardcoded to say n/a -->
                    @if (csd.summaryType === 'R') {
                      <div>{{ i18nService.formatPercent(formatCreditAvailable(csd)) | async }}</div>
                    }
                    @if (csd.summaryType !== 'R') {
                      <div>{{ 'content.not-available-short' | translate }}</div>
                    }
                  </div>
                </div>
              }
              @if (isCreditFreezeMessageExists(consumer) && !isCreditFreezeAndIsNonExemptedMC(consumer)) {
                <div class="row credit-freeze-msg">
                  <div class="col-6">{{ 'content.credit-freeze-msg-exempt' | translate }}{{ 'content.credit-freeze-date' | translate:{freezedate: getCreditFreezeDate(consumer)} }}</div>
                </div>
              }
            </div>
          }
          @if (hasHrfa(consumer?.hawk) || consumer.transAlert?.length > 0) {
            <div>
              <h2>{{ 'content.messages' | translate }}</h2>
              @if (consumer.transAlert?.length > 0;) {
                <div>
                  @for (t of consumer.transAlert || []; track t; let i = $index) {
                    <div>
                      @if (i === 0) {
                        <div>
                          <div class="row">
                            <div class="col-3">
                              <h3>{{ 'content.idmismatch-alert' | translate }}</h3>
                            </div>
                            <div class="col-3 col-lg-6">{{ t.alertText }}</div>
                          </div>
                        </div>
                      }
                      @if (i > 0) {
                        <div>
                          <div class="row">
                            <div class="col-3"></div>
                            <div class="col-3 col-lg-6">{{ t.alertText }}</div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (isHrfaClear(consumer?.hawk)) {
                <div class="row">
                  <div class="col-3">
                    <h3>{{ 'content.high-risk-fraud-alert' | translate }}</h3>
                  </div>
                  <div class="col-3 col-lg-6">
                    <div>{{ 'content.clear' | translate }}</div>
                  </div>
                </div>
              }
              @for (hrfa of hrfa(consumer?.hawk) | keyvalue; track hrfa; let i = $index) {
                <div>
                  @if (i === 0) {
                    <div>
                      <div class="row">
                        <div class="col-3">
                          <h3>{{ 'content.high-risk-fraud-alert' | translate }}</h3>
                        </div>
                        <div class="col-3 col-lg-6">{{ hrfa.value }}</div>
                      </div>
                    </div>
                  }
                  @if (i > 0) {
                    <div>
                      <div class="row">
                        <div class="col-3"></div>
                        <div class="col-3 col-lg-6">{{ hrfa.value }}</div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (consumer.scores?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.scores' | translate }}</h2>
              @for (s of consumer.scores; track s; let i = $index) {
                <div>
                  @if (i > 0) {
                    <br/>
                  }
                  <div class="row">
                    <h3 class="col-6 col-md-2 pdf-18-percent">{{ s.scoreName }}</h3>
                    <div class="col-6 col-md-1">{{ s.score }}</div>
                    <div class="col-12 col-md-9"></div>
                  </div>
                  @for (aac of aacList(s); track aac) {
                    <div class="row">
                      <div class="col-6 col-md-2 pdf-18-percent"></div>
                      <div class="col-6 col-md-1">{{ aac[0] }}</div>
                      <div class="col-12 col-md-9">{{ aac[1] }}</div>
                    </div>
                  }
                  @if (isProductAddonCode703(s)) {
                    <div class="row">
                      <div class="col-6 col-md-2 pdf-18-percent"></div>
                      <div class="col-6 col-md-1"></div>
                      <div class="col-12 col-md-9">{{ s.inquiryImpact }}</div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (consumer.banking?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.banking' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <div class="col-3 h3">&nbsp;</div>
                <h3 class="col">{{ 'content.reptd' | translate }}</h3>
                <h3 class="col">{{ 'content.open' | translate }}</h3>
                <h3 class="col">{{ 'content.write-off' | translate }}</h3>
                <h3 class="col">{{ 'content.amount' | translate }}</h3>
                <h3 class="col-3">{{ 'content.reason' | translate }}</h3>
              </div>
              @for (b of consumer.banking; track b) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <div class="d-lg-none h3">&nbsp;</div>
                    <div class="d-flex flex-row justify-content-between">
                      <div class="me-4">{{ kob(b.subscriberCode) }}</div>
                      <div>{{ b.subscriberName }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(b.dateVerified) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.open' | translate }}</h3>
                    <div>{{ monthYear(b.dateOpened) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.write-off' | translate }}</h3>
                    <div>{{ monthYear(b.dateClosed) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.amount' | translate }}</h3>
                    <div>{{ formatCurrency(b.balance) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <h3 class="d-lg-none">{{ 'content.reason' | translate }}</h3>
                    <div>{{ b.statusText }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (getTrades(consumer)?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.trade' | translate }}</h2>
              @for (t of getTrades(consumer) || []; track t; let i = $index) {
                <div class="row" [ngClass]="{'mt-4': i > 0}">
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <div class="h3">&nbsp;</div>
                    <div class="d-flex flex-row justify-content-between">
                      <div class="me-4">{{ kob(t.subscriberCode) }}</div>
                      <div>{{ t.subscriberName }}, {{ t.subscriberPhone }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(t.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.open' | translate }}</h3>
                    <div>{{ monthYear(t.dateOpened) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.last' | translate }}</h3>
                    <div>{{ monthYear(t.dateLastActivity) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.h-credit' | translate }}</h3>
                    <div>{{ highCreditOrCreditLimit(t) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.balance' | translate }}</h3>
                    <div>{{ formatCurrency(t.balance) | async }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.past-due' | translate }}</h3>
                    <div>{{ formatCurrency(t.amountPastDue) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.terms' | translate }}</h3>
                    <div>{{ t.termsAmount }}/{{ t.termsFrequency }}</div>
                  </div>
                  <div class="col-sm-12 col-md-9 col-lg-4">
                    <h3>{{ 'content.payment-pattern' | translate }}</h3>
                    <div class="text-break">{{ formatPaymentPattern(t) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <h3>{{ 'content.30-60-90-m-mop' | translate }}</h3>
                    <div>{{ formatMop(t) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.mop' | translate }}</h3>
                    <div>{{ t.accountType }}{{ t.currentMOP }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-12 center-message">
                    <div>{{ formatNarrativeText(t.narrativeCodeText1 , t.narrativeCodeText2) }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.mortgages?.length > 0 && !hasScotiaTrades(consumer)) {
            <div class="break-after-avoid">
              <h2>{{ 'content.mortgage' | translate }}</h2>
              @for (m of consumer.mortgages || []; track m; let i = $index) {
                <div class="row" [ngClass]="{'mt-4': i > 0}">
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <div class="h3">&nbsp;</div>
                    <div class="d-flex flex-row justify-content-between">
                      <div class="me-4">{{ kob(m.subscriberCode) }}</div>
                      <div></div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(m.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.open' | translate }}</h3>
                    <div>&nbsp;</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.last' | translate }}</h3>
                    <div>{{ monthYear(m.dateLastActivity) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.h-credit' | translate }}</h3>
                    <div>{{ highCreditOrCreditLimit(m) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.balance' | translate }}</h3>
                    <div>{{ formatCurrency(m.balance) | async }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.past-due' | translate }}</h3>
                    <div>{{ formatCurrency(m.amountPastDue) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.terms' | translate }}</h3>
                    <div>{{ m.termsAmount }}/{{ m.termsFrequency }}</div>
                  </div>
                  <div class="col-sm-12 col-md-9 col-lg-4">
                    <h3>{{ 'content.payment-pattern' | translate }}</h3>
                    <div class="text-break">{{ formatPaymentPattern(m) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <h3>{{ 'content.30-60-90-m-mop' | translate }}</h3>
                    <div>{{ formatMop(m) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.mop' | translate }}</h3>
                    <div>{{ m.accountType }}{{ m.currentMOP }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-12 center-message">
                    <div>{{ formatNarrativeText(m.narrativeCodeText1 , m.narrativeCodeText2) }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.alternativeTrades?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.alt-trades' | translate }}</h2>
              @for (t of consumer.alternativeTrades || []; track t; let i = $index) {
                <div class="row" [ngClass]="{'mt-4': i > 0}">
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <div class="h3">&nbsp;</div>
                    <div class="d-flex flex-row justify-content-between">
                      <div class="me-4">{{ kob(t.subscriberCode) }}</div>
                      <div>{{ t.subscriberName }}, {{ t.subscriberPhone }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(t.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.open' | translate }}</h3>
                    <div>{{ monthYear(t.dateOpened) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.last' | translate }}</h3>
                    <div>{{ monthYear(t.dateLastActivity) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.h-credit' | translate }}</h3>
                    <div>{{ highCreditOrCreditLimit(t) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.balance' | translate }}</h3>
                    <div>{{ formatCurrency(t.balance) | async }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.past-due' | translate }}</h3>
                    <div>{{ formatCurrency(t.amountPastDue) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.terms' | translate }}</h3>
                    <div>{{ t.termsAmount }}/{{ t.termsFrequency }}</div>
                  </div>
                  <div class="col-sm-12 col-md-9 col-lg-4">
                    <h3>{{ 'content.payment-pattern' | translate }}</h3>
                    <div class="text-break">{{ formatPaymentPattern(t) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <h3>{{ 'content.30-60-90-m-mop' | translate }}</h3>
                    <div>{{ formatMop(t) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3>{{ 'content.mop' | translate }}</h3>
                    <div>{{ t.accountType }}{{ t.currentMOP }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col-12 center-message">
                    <div>{{ formatNarrativeText(t.narrativeCodeText1 , t.narrativeCodeText2) }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.registeredItems?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.registered-items' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <div class="col-3 h3">&nbsp;</div>
                <h3 class="col">{{ 'content.reptd' | translate }}</h3>
                <h3 class="col">{{ 'content.open' | translate }}</h3>
                <h3 class="col">{{ 'content.mature' | translate }}</h3>
                <h3 class="col">{{ 'content.amount' | translate }}</h3>
                <h3 class="col">{{ 'content.security' | translate }}</h3>
                <div class="col h3">&nbsp;</div>
              </div>
              @for (r of consumer.registeredItems || []; track r) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-3">
                    <div class="d-lg-none h3">&nbsp;</div>
                    <div class="d-flex flex-row justify-content-between">
                      <div class="me-4">{{ kob(r.subscriberCode) }}</div>
                      <div>{{ formatSubscriber(r) }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(r.dateRevised) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.open' | translate }}</h3>
                    <div>{{ monthYear(r.dateFiled) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg">
                    <h3 class="d-lg-none">{{ 'content.mature' | translate }}</h3>
                    <div>{{ monthYear(r.dateMature) }}</div>
                  </div>
                  <div class="col-sm-6 col-md">
                    <h3 class="d-lg-none">{{ 'content.amount' | translate }}</h3>
                    <div>{{ formatCurrency(r.originalBalance) | async }}</div>
                  </div>
                  <div class="col-sm-6 col-md">
                    <h3 class="d-lg-none">{{ 'content.security' | translate }}</h3>
                    <div>{{ r.security }}</div>
                  </div>
                  <div class="col-sm-6 col-lg">
                    <div class="d-lg-none h3">&nbsp;</div>
                    <div>{{ formatRegisteredItemNarrativeCodes(r) }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.bankruptcies?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.bankruptcy-and-insolvency' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-1">{{ 'content.revised-short' | translate }}</h3>
                <h3 class="col-1">{{ 'content.reptd' | translate }}</h3>
                <h3 class="col-4 pdf-reactor-left-pad-1">{{ 'content.trustee' | translate }}</h3>
                <h3 class="col-4">{{ 'content.assets' | translate }}</h3>
                <h3 class="col-2">{{ 'content.liabilities-short' | translate }}</h3>
              </div>
              @for (b of consumer.bankruptcies || []; track b) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-1">
                    <h3 class="d-lg-none">{{ 'content.revised-short' | translate }}</h3>
                    <div>{{ monthYear(b.dateRevised) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-1">
                    <h3 class="d-lg-none">{{ 'content.reptd' | translate }}</h3>
                    <div>{{ dayMonthYear(b.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-4 pdf-reactor-left-pad-1">
                    <h3 class="d-lg-none">{{ 'content.trustee' | translate }}</h3>
                    <div class="d-flex flex-column">
                      <div>{{ b.trusteeName }}</div>
                      <div>{{ b.trusteeCompanyName }}</div>
                      <div>{{ b.thirdPartyName }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <h3 class="d-lg-none">{{ 'content.assets' | translate }}</h3>
                    <div class="d-flex flex-column">
                      <div>{{ b.assets }}</div>
                      <div>{{ b.bkStatusCode }} {{ dayMonthYear(b.dateDischarged) }}</div>
                      <div>{{ b.narrativeCode }}</div>
                      <div>{{ b.courtFilingNumber }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-2">
                    <h3 class="d-lg-none">{{ 'content.liabilities-short' | translate }}</h3>
                    <div>{{ formatCurrency(b.liabilities) | async }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.legals?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.legal-items' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-1">{{ 'content.revised-short' | translate }}</h3>
                <h3 class="col-1">{{ 'content.reptd' | translate }}</h3>
                <h3 class="col-4">{{ 'content.plaintiffs-name' | translate }}</h3>
                <h3 class="col-4">{{ 'content.amount' | translate }}</h3>
                <h3 class="col-2">{{ 'content.balance' | translate }}</h3>
              </div>
              @for (l of consumer.legals; track l) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-1">
                    <h3 class="d-lg-none">{{ 'content.revised-short' | translate }}</h3>
                    <div>{{ monthYear(l.dateRevised) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-1">
                    <h3 class="d-lg-none">{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(l.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-4">
                    <h3 class="d-lg-none">{{ 'content.plaintiffs-name' | translate }}</h3>
                    <div class="d-flex flex-column">
                      <div>{{ l.plaintiff }}</div>
                      <div>{{ l.informationReference }}, {{ l.court }}</div>
                      <div>{{ l.legalType }}, {{ l.caseFile }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <h3 class="d-lg-none">{{ 'content.amount' | translate }}</h3>
                    <div class="d-flex flex-column">
                      <div>{{ formatCurrency(l.original) | async }}</div>
                      <div>{{ l.narrativeCode1 }}, {{ monthYear(l.dateSatisfied) }}</div>
                      <div>{{ l.statusCode }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-2">
                    <h3 class="d-lg-none">{{ 'content.balance' | translate }}</h3>
                    <div>{{ formatCurrency(l.balance) | async }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.collections?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.collections' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-1">{{ 'content.revised-short' | translate }}</h3>
                <h3 class="col-1">{{ 'content.reptd' | translate }}</h3>
                <h3 class="col-4">{{ 'content.creditors-name' | translate }}</h3>
                <h3 class="col-4">{{ 'content.amount' | translate }}</h3>
                <h3 class="col-2">{{ 'content.balance' | translate }}</h3>
              </div>
              @for (c of consumer.collections || []; track c) {
                <div class="row">
                  <div class="col-sm-6 col-md-3 col-lg-1">
                    <h3 class="d-lg-none">{{ 'content.revised-short' | translate }}</h3>
                    <div>{{ monthYear(c.dateVerified) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-1">
                    <h3 class="d-lg-none">{{ 'content.reptd' | translate }}</h3>
                    <div>{{ monthYear(c.dateReported) }}</div>
                  </div>
                  <div class="col-sm-6 col-md-3 col-lg-4">
                    <h3 class="d-lg-none">{{ 'content.creditors-name' | translate }}</h3>
                    <div>{{ c.collAgencyName }}/{{ c.creditorName }}</div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <h3 class="d-lg-none">{{ 'content.amount' | translate }}</h3>
                    <div class="d-flex flex-column">
                      <div>{{ formatCurrency(c.origBalanace) | async }}</div>
                      <div>{{ formatCollectionStatus(c) ?? '&nbsp;' }}</div>
                      <div>{{ formatCollectionNarratives(c) }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-2">
                    <h3 class="d-lg-none">{{ 'content.balance' | translate }}</h3>
                    <div>{{ formatCurrency(c.currentBalance) | async }}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (consumer.inquiries?.length > 0) {
            <div class="break-after-avoid">
              <h2>{{ 'content.inquiries' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-2">{{ 'content.date' | translate }}</h3>
                <h3 class="col-8">{{ 'content.credit-grantor' | translate }}</h3>
              </div>
              @for (i of consumer.inquiries; track i) {
                <div class="row">
                  <div class="col-12 col-lg-2">
                    <h3 class="d-lg-none">{{ 'content.date' | translate }}</h3>
                    <div>{{ dayMonthYear(i.inquiryDate) }}</div>
                  </div>
                  <div class="col-12 col-lg-10">
                    <h3 class="d-lg-none">{{ 'content.credit-grantor' | translate }}</h3>
                    <div class="row">
                      <div class="col-1">{{ kob(i.subscriberCode) }}</div>
                      <div class="col-11">{{ i.memberName }}{{ i.memberPhoneNumber ? ', ' + i.memberPhoneNumber : '' }}</div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (hasRemarks(consumer)) {
            <div class="break-after-avoid">
              <h2>{{ 'content.remarks' | translate }}</h2>
              <div class="d-none d-lg-flex row ps-0 pe-0">
                <h3 class="col-2">{{ 'content.date' | translate }}</h3>
                <h3 class="col-10">{{ 'content.information' | translate }}</h3>
              </div>
              @for (remark of remarks(consumer); track remark) {
                <div class="row">
                  <div class="col-12 col-lg-2">
                    <h3 class="d-lg-none">{{ 'content.date' | translate }}</h3>
                    <div>{{ dayMonthYear(remark.date, 'DDMMYYYY') }}</div>
                  </div>
                  <div class="col-12 col-lg-10">
                    <h3 class="d-lg-none">{{ 'content.information' | translate }}</h3>
                    <div>{{ remark.type }} {{ remark.message }}</div>
                  </div>
                </div>
              }
            </div>
          }
          <div class="report-complete-msg pt-3">
            @if (!isCreditFreezeAndIsNonExemptedMC(consumer)) {
              <strong >{{ 'content.this-completes-the-file-for' | translate:{
                givenNames: primaryGivenNames(consumer),
                lastName: primaryName(consumer)?.lastName
              } }}</strong>
            } @else {
              <div>{{ 'content.this-completes-the-file-for-freeze' | translate: {fullname: getFullNameFromConsumerRequest(consumer, consumerRequest)} }}</div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
